import React from "react";
import ScreenPanel from "./ScreenPanel";

const QuadScreen = ({ 
  competitionId, 
  configs, 
  onConfigChange, 
  onSettingsClick, 
  onSwitchScreenMode,
  routes, 
  t 
}) => {
  return (
    <div className="quad-screen">
      <div className="quad-screen-container">
        <div className="quad-grid">
          {configs.map((config, index) => (
            <div key={index} className="quad-panel">
              <ScreenPanel
                competitionId={competitionId}
                config={config}
                onConfigChange={(newConfig) => onConfigChange(index, newConfig)}
                onSettingsClick={() => onSettingsClick(index)}
                onSwitchScreenMode={onSwitchScreenMode}
                routes={routes}
                t={t}
                isQuadMode={true}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuadScreen;